import React from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { ReactTableDefaults } from 'react-table';
import { toast } from 'react-toastify';

import logo from './logo.svg';
import './App.css';

import Api from './constants/Api';
import General from './constants/General';

import Backend from './utils/Backend'

import Branding from './pages/components/common/Branding';

import AuthenticatedRoute from './components/AuthenticatedRoute';
import UnauthenticatedRoute from './components/UnauthenticatedRoute';

import Pagination from './pages/components/tables/Pagination';

import './assets/css/metronic-7.0.2/pages/login/login-1.css'
import './assets/plugins/global/plugins.bundle.css';
import './assets/plugins/custom/prismjs/prismjs.bundle.css';
import './assets/css/style.bundle.css';
import './assets/css/themes/layout/header/base/light.css';
import './assets/css/themes/layout/header/menu/light.css';
import './assets/css/themes/layout/brand/light.css';
import './assets/css/themes/layout/aside/light.css';
import './assets/css/custom.css';
import './assets/css/wizard-2.css';
import './assets/css/style.bundle-7.0.2.css';
import "./assets/scss/app.scss"

import AuthApp from './pages/App'
import Login from "./pages/Login";

Object.assign(ReactTableDefaults, {
  minRows: 0,
  PaginationComponent: Pagination
})

toast.configure()

export default class App extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      loading: true,
    }
  }

  componentDidMount() {
    document.addEventListener('wheel', this._preventNumberInputScroll, { passive: true })

    let scripts = []
    scripts.push(
      this._getScript(process.env.PUBLIC_URL + '/assets/plugins/global/plugins.bundle.js')
    )
    scripts.push(
      this._getScript(process.env.PUBLIC_URL + '/assets/plugins/custom/prismjs/prismjs.bundle.js')
    )
    scripts.push(
      this._getScript(process.env.PUBLIC_URL + '/assets/js/scripts.bundle.js')
    )
    scripts.push(
      this._getScript(process.env.PUBLIC_URL + '/assets/js/custom.js')
    )

    this._addScripts(scripts)

    Backend.getBranding()
    .then(branding => {
      window.General.Branding.Name = branding.platform_name
      window.General.Branding.LinkName = branding.link_name
      window.General.Branding.Colors = branding.colors

      if(branding.logo){
        window.General.Branding.Logo = branding.logo?.original
      }

      if(branding.banner){
        window.General.Branding.Banner = branding.banner?.original
      }

      if(branding.favicon){
        window.General.Branding.Favicon = branding.favicon?.thumbnail
      }

      window.General.Branding.Domain = branding.domain
      window.General.WebsiteDomain = branding.domain
      window.General.WebsiteUrl = `https://${branding.domain}`
      this.setState({ loading: false })
    })
    .catch(() => {
      this.setState({ loading: false })
    })
  }

  componentWillUnmount() {
    document.removeEventListener('wheel', this._preventNumberInputScroll, { passive: true })
  }

  _preventNumberInputScroll = (e) => {
    const element = document.activeElement
    if (element && element.type === "number" && element === e.target) {
      element.blur();
    }
  }

  _getScript(path) {
    const script = document.createElement('script')

    script.src = path

    return script
  }

  // TO:DO remove need for sleep, the issue is vendors.bundle.js, takes too long to load
  // and scripts.bundle.js executes before it finishes causing all sorts of errors.
  async _addScripts(scripts) {
    for (var i = 0; i < scripts.length; i++) {
      let script = scripts[i]
      document.body.appendChild(script)
      await this._sleep(500)
    }
  }

  _sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }

  render() {
    let {
      loading
    } = this.state

    if(loading){
      return null
    }

    return (
      <>
        <BrowserRouter>
          <Switch>
            <UnauthenticatedRoute exact path="/login" component={Login} />
            {/*<UnauthenticatedRoute exact path="/forgot-password" component={ForgotPassword} />*/}
            {/*<UnauthenticatedRoute path="/reset-password/:email" component={ResetPassword} />*/}

            <AuthenticatedRoute path="/" component={AuthApp} />

            {/*<Route exact path="/404" component={NotFound} />*/}
            <Redirect to="/404" />
          </Switch>
        </BrowserRouter>
        <Branding name="Console"/>
      </>
    )
  }
}
